module.exports = __webpack_public_path__ + "media/images/icon_arrow_gray2-2d75cfb25252e0f9c595e4ec25c4de4c.png";